<template>
  <div class="page-free-exit-record page-content" v-loading="body_loading">
    <div class="main-body">
      <el-row class="hd">
        <el-col :span="12">
          <h3 style="float: none;">免费出场记录</h3>
          <div class="flex-block breadcrumb-box">
            <div class="position-text">位置:</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>停车管理</el-breadcrumb-item>
              <el-breadcrumb-item>免费出场记录</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
      <div class="bd">
        <div class="search-block">
          <el-form :inline="true" :model="search_form" class="demo-form-inline">
            <el-form-item label="车牌号:">
              <el-input size="small" v-model="search_form.carNum" placeholder="请输入车牌号"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="用户姓名:">
              <el-input size="small" v-model="search_form.userName" placeholder="请输入用户姓名"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="用户手机号:">
              <el-input size="small" v-model="search_form.userPhoneNumber" placeholder="请输入用户手机号"
                        clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
              <el-button size="small" @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-block content-body">
          <div ref="contentBody">
            <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark"
                      style="width: 100%;text-align: center;">
              <el-table-column prop="carNum" align="center" label="车牌号" min-width="120"></el-table-column>
              <el-table-column prop="userName" align="center" label="用户姓名" min-width="120"></el-table-column>
              <el-table-column prop="userPhoneNumber" align="center" label="用户手机号" min-width="140"></el-table-column>
<!--              <el-table-column prop="userOrgName" align="center" label="用户组织名称" min-width="150"></el-table-column>-->
<!--              <el-table-column prop="createUserName" align="center" label="创建人姓名" min-width="120"></el-table-column>-->
<!--              <el-table-column prop="iccId" align="center" label="ICC ID" min-width="120"></el-table-column>-->
              <el-table-column prop="createdate" align="center" label="创建时间" min-width="160"></el-table-column>
            </el-table>
          </div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="table_data.page_info.page" :page-sizes="[10,30,50,80,100]"
                         :page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
                         :total="table_data.page_info.total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'freeExitRecordList',
  data() {
    return {
      body_loading: false,
      search_form: {
        carNum: '',
        userName: '',
        userPhoneNumber: ''
      },
      table_data: {
        loading: false,
        list: [],
        page_info: {
          page: 1,
          pageSize: 10,
          total: 0
        }
      }
    }
  },
  created() {
    document.title = '免费出场记录';
    this.getList();
  },
  methods: {
    getList() {
      var _this = this;
      var params = {
        pageNo: _this.table_data.page_info.page,
        pageSize: _this.table_data.page_info.pageSize,
        carNum: _this.search_form.carNum,
        userName: _this.search_form.userName,
        userPhoneNumber: _this.search_form.userPhoneNumber
      };
      _this.table_data.loading = true;
      this.$client.get('/api/biz/parking/free/getList', params, function (res, message, total) {
        _this.table_data.list = res;
        _this.table_data.page_info.total = total;
        _this.table_data.loading = false;
      }, function (res) {
        _this.table_data.loading = false;
      });
    },
    handleSizeChange(val) {
      this.table_data.page_info.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.table_data.page_info.page = val;
      this.getList();
    },
    handleSearch() {
      this.table_data.page_info.page = 1;
      this.getList();
    },
    handleReset() {
      this.search_form.carNum = '';
      this.search_form.userName = '';
      this.search_form.userPhoneNumber = '';
      this.table_data.page_info.page = 1;
      this.getList();
    }
  }
}
</script>
<style scoped>
.search-block {
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
}
</style>
